const handleInput = (e) => {
    this.setState({ input: e.target.value })
}
const numberWithCommas = (x) => {
    var parts = x.toString().split(".");
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return parts.join(".");
}
const insert = (str, index, value) => {
    return str.substr(0, index) + value + str.substr(index);
}

const editLine = (data, fLength, lLength) => {
    if (data) {
        data = data.replace(/\u21b5/g, ' ')
        data = data.replace(/(?:\r\n|\r|\n)/g, ' ')
        let a = 0
        let spaceIndex = data.indexOf(' ')
        while (spaceIndex !== -1) {
            if (a + fLength < spaceIndex && spaceIndex < a + lLength) {
                data = insert(data, spaceIndex, '\n')
                a = spaceIndex
                spaceIndex = data.indexOf(' ', a)
            }
            spaceIndex = data.indexOf(' ', spaceIndex + 1)
        }
        return data
    } else {
        return ''
    }
}
function convertDate(inputFormat) {
    function pad(s) { return (s < 10) ? '0' + s : s; }
    var d = new Date(inputFormat);
    return [pad(d.getDate()), pad(d.getMonth() + 1), d.getFullYear()].join('/');
}
var nameLob = require('./download')
var pdfConverter = require('jspdf')
const onPrint = (licenseID) => {
    // console.log(licenseID)
    const url = 'https://backend2.riceinspections.com'
    fetch(`${url}/search?code=${licenseID}`)
    .then(res => res.json())
    .then((data) => {
        // console.log(data)
        if (typeof data == 'object') {
            console.log('in loop')
            var doc = new pdfConverter('p', 'mm', 'a4')
            const mark = (tempDoc) => {
                if (data.ExportBy.indexOf('เรือ') != -1) {
                    return tempDoc.text(50.5, 113.5, 'X')
                } else if (data.ExportBy === 'บก') {
                    return tempDoc.text(60.5, 113.5, 'X')
                } else if (data.ExportBy === 'อากาศ') {
                    return tempDoc.text(70.5, 113.5, 'X')
                } else if (data.ExportBy === 'ไปรษณีย์') {
                    return tempDoc.text(85.5, 113.5, 'X')
                } else return tempDoc
            }
            const editHeader = (tempDoc) => {
                if (data.Product.indexOf('ข้าวเอกชน') != -1) {
                    // return tempDoc.text()
                }
            }
            doc.addFileToVFS('thai.ttf', nameLob.name())
            doc.addFont('thai.ttf', 'thai', 'normal')
            doc.setFont('thai')
            doc.setFontSize(14)
            doc = mark(doc)
            // console.log('mark doc')
            // doc = editHeader(doc)
            //  doc.setFontSize(16)
            //แนวนอน แนวตั้ง กว้าง สูง
            let recip = editLine(data.Recipient, 50, 70)
            let exportAgent = editLine(data.Export_Agent, 50, 70)
            let exporter = editLine(data.Exporter, 50, 70)
            let buyer = editLine(data.Buyer, 50, 70)
        
            doc.setTextColor(255, 0, 0); doc.text(5, 7, `${data.Product}`)
            doc.rect(5, 10, 100, 35); doc.setFontSize(14); doc.setTextColor(255, 0, 0); doc.text(6, 15, 'ผู้ส่งออก (ชื่อ,ที่อยู่,โทรศัพท์)')
            doc.setFontSize(13); doc.setTextColor(0, 0, 0); doc.text(6, 22, `${recip}`)
            doc.rect(5, 45, 100, 30); doc.setFontSize(14); doc.setTextColor(255, 0, 0); doc.text(6, 50, 'ผู้รับสินค้า(ชื่อ,ที่อยู่)')
            doc.setFontSize(13); doc.setTextColor(0, 0, 0); doc.text(6, 55, `${exporter}`)
            doc.rect(5, 75, 100, 30); doc.setFontSize(14); doc.setTextColor(255, 0, 0); doc.text(6, 80, 'ผู้ทำการแทนผู้ส่งออก(ชื่อ,ที่อยู่,ฐานะ)')
            doc.setFontSize(13); doc.setTextColor(0, 0, 0); doc.text(6, 85, `${exportAgent}`)
            doc.rect(5, 105, 100, 10); doc.setFontSize(12); doc.setTextColor(255, 0, 0); doc.text(6, 109, 'วันส่งออก(โดยประมาณ)                 ส่งออกโดยทาง'); doc.setTextColor(0)
            doc.text(11, 113.5, `${data.ExportDate}`); doc.rect(50, 111, 3, 3); doc.text(55, 113.5, 'เรือ'); doc.rect(60, 111, 3, 3); doc.text(65, 113.5, 'บก'); doc.rect(70, 111, 3, 3); doc.text(75, 113.5, 'อากาศ'); doc.rect(85, 111, 3, 3); doc.text(90, 113.5, 'ไปรษณีย์'); doc.setTextColor(255, 0, 0)
            doc.rect(5, 115, 100, 7.5); doc.setFontSize(14); doc.setTextColor(255, 0, 0); doc.text(6, 120, 'ชื่อพาหนะ/เที่ยว')
            doc.setFontSize(14); doc.setTextColor(0, 0, 0); doc.text(40, 120, `${data.Vehicle}`)
            doc.rect(5, 122.5, 100, 7.5); doc.setFontSize(14); doc.setTextColor(255, 0, 0); doc.text(6, 127.5, 'ท่าเรื่อที่ส่งออก')
            doc.setFontSize(14); doc.setTextColor(0, 0, 0); doc.text(40, 127.5, `${data.PortName}`)
        
            doc.setFontSize(16); doc.setTextColor(255, 0, 0); doc.text(93, 7, '(สำเนา)')
            doc.rect(50, 10, 55, 7.5); doc.setFontSize(10); doc.setTextColor(255, 0, 0); doc.text(52, 15, 'เลขประจำตัวผู้เสียภาษีอากร'); doc.setFontSize(10); doc.setTextColor(0, 0, 0); doc.text(80, 15, `${data.CompanyTax}`); doc.setFontSize(16);
        
            doc.setTextColor(255, 0, 0); doc.text(145, 7, 'ใบอนุญาต'); doc.setTextColor(255, 0, 0); doc.text(190, 7, 'แบบ อ.๒')
            doc.setTextColor(255, 0, 0); doc.text(130, 17, 'ให้ส่งสินค้าออกไปนอกราชอาณาจักร')
            doc.setTextColor(255, 0, 0); doc.text(115, 27, '(สินค้า..............................ข้าว.....................................)')
            doc.rect(105, 30, 50, 15); doc.setFontSize(14); doc.text(106, 35, 'เลขที่'); doc.setTextColor(0, 0, 0); doc.setFontSize(16); doc.text(115, 35, `${data.LicenseNumber}`)
            doc.rect(155, 30, 50, 15); doc.setFontSize(14); doc.text(156, 35, 'ใช้ได้ถึงวันที่'); doc.setTextColor(0, 0, 0); doc.setFontSize(16); doc.text(185, 35, `${data.ExpiredDate}`)
            doc.rect(105, 45, 100, 30); doc.setFontSize(14); doc.setTextColor(255, 0, 0); doc.text(106, 50, 'ผู้ซื้อ (ชื่อ,ที่อยู่,ในกรณีที่เป็นคนละรายกับผู้รับสินค้า)')
            doc.setFontSize(13); doc.setTextColor(0); doc.text(106, 55, `${buyer}`)
            doc.rect(105, 75, 100, 10); doc.setFontSize(14); doc.setTextColor(255, 0, 0); doc.text(106, 80, 'ประเทศผู้ซื้อ'); doc.setTextColor(0, 0, 0); doc.setFontSize(14); doc.text(140, 80, `${data.DestinationCountry}`)
            doc.rect(105, 85, 100, 10); doc.setFontSize(14); doc.setTextColor(255, 0, 0); doc.text(106, 90, 'ประเทศปลายทาง'); doc.setTextColor(0, 0, 0); doc.setFontSize(14); doc.text(140, 90, `${data.BuyerCountry}`)
            doc.rect(105, 95, 100, 27.5); doc.setFontSize(14); doc.setTextColor(255, 0, 0); doc.text(106, 100, 'สำหรับเจ้าหน้าที่ศุลกากรบันทึก (หากไม่พอให้ต่อด้านหลัง)')
            doc.rect(105, 122.5, 60, 7.5); doc.setFontSize(12); doc.setTextColor(255, 0, 0); doc.text(106, 127.5, 'สกุลเงิน'); doc.setTextColor(0, 0, 0); doc.setFontSize(16); doc.text(130, 127.5, `${data.Currency}`)
            doc.rect(165, 122.5, 40, 7.5); doc.setFontSize(12); doc.setTextColor(255, 0, 0); doc.text(166, 127.5, 'อัตราแลกเปลี่ยน'); doc.setTextColor(0, 0, 0); doc.setFontSize(16); doc.text(186, 127.5, `${data.ExchangeRate}`)
        
            doc.setFontSize(11); doc.setTextColor(255, 0, 0);
            doc.text(6, 134, 'รายละเอียดสินค้า')
            doc.text(126, 134, 'ประเภทพิกัด'); doc.text(166, 134, 'น้ำหนักสุทธิ(ก.ก.)/ปริมาณ')
            doc.text(126, 146.5, 'ราคาต่อหน่วย'); doc.text(166, 146.5, 'มูลค่าเอฟโอบี(เงินบาท)')
        
            doc.text(126, 159, 'ประเภทพิกัด'); doc.text(166, 159, 'น้ำหนักสุทธิ(ก.ก.)/ปริมาณ')
            doc.text(126, 171.5, 'ราคาต่อหน่วย'); doc.text(166, 171.5, 'มูลค่าเอฟโอบี(เงินบาท)')
        
            doc.text(126, 184, 'ประเภทพิกัด'); doc.text(166, 184, 'น้ำหนักสุทธิ(ก.ก.)/ปริมาณ')
            doc.text(126, 196.5, 'ราคาต่อหน่วย'); doc.text(166, 196.5, 'มูลค่าเอฟโอบี(เงินบาท)')
        
            doc.text(126, 209, 'ประเภทพิกัด'); doc.text(166, 209, 'น้ำหนักสุทธิ(ก.ก.)/ปริมาณ')
            doc.text(126, 221.5, 'ราคาต่อหน่วย'); doc.text(166, 221.5, 'มูลค่าเอฟโอบี(เงินบาท)')
        
            let pp = data.PaperlessDetail.LicenseDetail
            if(!Array.isArray(pp)) {
                pp = [pp]
            }
            pp.map((value) => {

                let KGM = value['NetWeightKGM']
                if(!Number.isFinite(KGM)){
                  KGM = parseFloat(KGM.replace(',',''))
                }
          
                value['NetWeightKGM'] = numberWithCommas(KGM)
                value['PricePerUnit'] = numberWithCommas(value['PricePerUnit'])
                value['FOB'] = numberWithCommas(value['FOB'])
                value['Quantity'] = numberWithCommas(value['Quantity'])
            })
            const handleData = (index, topic) => {
                let temp = pp[index]
                if (temp && temp[topic]) {
                    temp = temp[topic]
                    return temp
                } else {
                    temp = '****************'
                    return temp
                }
            }
            const handleDataNull = (index, topic) => {
                let temp = pp[index]
                if (temp && temp[topic]) {
                    temp = temp[topic]
                    return temp
                } else {
                    temp = ''
                    return temp
                }
            }
            doc.setTextColor(0); doc.setFontSize(13)
            doc.text(6, 139, `${editLine(handleData(0, 'ProductDescription'), 50, 90)}`)
            doc.text(126, 138, `${handleData(0, 'TariffType')}`); doc.text(166, 138, `${handleData(0, 'NetWeightKGM')}/${handleDataNull(0, 'Quantity')} ${handleDataNull(0, 'QuantityUnit')}`)
            doc.text(126, 150.5, `${handleData(0, 'PricePerUnit')} USD/ตัน`); doc.text(166, 150.5, `${handleData(0, 'FOB')}`)
            doc.text(6, 164, `${editLine(handleData(1, 'ProductDescription'), 50, 90)}`)
            doc.text(126, 163, `${handleData(1, 'TariffType')}`); doc.text(166, 163, `${handleData(1, 'NetWeightKGM')}/${handleDataNull(1, 'Quantity')} ${handleDataNull(1, 'QuantityUnit')}`)
            doc.text(126, 175.5, `${handleData(1, 'PricePerUnit')} USD/ตัน`); doc.text(166, 175.5, `${handleData(1, 'FOB')}`)
            doc.text(6, 189, `${editLine(handleData(2, 'ProductDescription'), 50, 90)}`)
            doc.text(126, 188, `${handleData(2, 'TariffType')}`); doc.text(166, 188, `${handleData(2, 'NetWeightKGM')}/${handleDataNull(2, 'Quantity')} ${handleDataNull(2, 'QuantityUnit')}`)
            doc.text(126, 200.5, `${handleData(2, 'PricePerUnit')} USD/ตัน`); doc.text(166, 200.5, `${handleData(2, 'FOB')}`)
            doc.text(6, 214, `${editLine(handleData(3, 'ProductDescription'), 50, 90)}`)
            doc.text(126, 213, `${handleData(3, 'TariffType')}`); doc.text(166, 213, `${handleData(3, 'NetWeightKGM')}/${handleDataNull(3, 'Quantity')} ${handleDataNull(3, 'QuantityUnit')}`)
            doc.text(126, 225.5, `${handleData(3, 'PricePerUnit')} USD/ตัน`); doc.text(166, 225.5, `${handleData(3, 'FOB')}`)
            doc.setTextColor(255, 0, 0); doc.text(6, 235, 'เงื่อนไขการอนุญาต'); doc.setTextColor(0)
            doc.text(8, 240, `${data.PermitConditions}`)
            doc.text(171, 252, `ออกเมื่อวันที่ ${convertDate(Date.now())}`)
            doc.rect(5, 130, 120, 25); doc.rect(125, 130, 40, 12.5); doc.rect(165, 130, 40, 12.5)
            doc.rect(125, 142.5, 40, 12.5); doc.rect(165, 142.5, 40, 12.5)
            doc.rect(5, 155, 120, 25); doc.rect(125, 155, 40, 12.5); doc.rect(165, 155, 40, 12.5)
            doc.rect(125, 167.5, 40, 12.5); doc.rect(165, 167.5, 40, 12.5)
            doc.rect(5, 180, 120, 25); doc.rect(125, 180, 40, 12.5); doc.rect(165, 180, 40, 12.5)
            doc.rect(125, 192.5, 40, 12.5); doc.rect(165, 192.5, 40, 12.5)
            doc.rect(5, 205, 120, 25); doc.rect(125, 205, 40, 12.5); doc.rect(165, 205, 40, 12.5)
            doc.rect(125, 217.5, 40, 12.5); doc.rect(165, 217.5, 40, 12.5)
            doc.rect(5, 230, 200, 25)
            // console.log(data)
            doc.output('dataurlnewwindow')
        } else {
            // this.setState({ warn: true })
        }
    })
}
 module.exports.onPrint = onPrint